<section class="splash-screen" aria-label="Écran de lancement Saloons">
  <div class="ambient ambient-top"></div>
  <div class="ambient ambient-bottom"></div>

  <div class="splash-content">
    <h1 class="brand-title" aria-label="SALOONS">
      <span>SAL</span><span class="brand-title-oo">OO</span><span>NS</span>
    </h1>
    <p class="brand-subtitle">Ici, on ne swipe pas. On se rencontre.</p>
  </div>
</section>
